<template>
  <v-container>
    <h2 class="mb-5">{{ title }}</h2>
    <div v-if="data.type === 'annotations_count'">
      <div v-if="data.available_annotations > 0">
        <router-link
          class="link my-3"
          :to="link_to + 'review'"
        >
          Review available annotations
          <v-icon class="icon">arrow_forward_ios</v-icon>
        </router-link>
      </div>
      <div v-else>
        <h4> There are currently no new annotations to review. </h4>
      </div>
    </div>
    <div v-else>
      <h3>Loading...</h3>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: ['title','link_to'],
  computed: mapState({
    data: state => state.currentPage.data,
  }),
  methods: {
    ...mapActions('currentPage', ['get']),
  },
  mounted() {
    this.get()
  }
}
</script>

<style lang="scss" scoped>
.link {
  font-size: 24px;
  display: flex;
  justify-content: space-between;
}

.icon {
  color: #007bff;
}
</style>
